import CoachMark from '#shared/CoachMark';
import { RegisteredCoachScheduleDetail } from '#types/schedule';
import MemberLink from './MemberLink';
import * as S from './styles';

interface MemberProps {
  data: RegisteredCoachScheduleDetail;
}

const Member = ({ data }: MemberProps) => {
  return (
    <S.LabeledInfo>
      <S.LabeledInfoTitle>회원</S.LabeledInfoTitle>
      <CoachMark.SpotLight style={{ padding: '8px', borderRadius: '12px' }}>
        <CoachMark.Tooltip
          position="bottom"
          message="회원 관리로 쉽게 이동할 수 있어요"
          tooltipStyle={{
            left: undefined,
            right: '12px',
            transform: undefined
          }}
          tooltipArrowStyle={{
            left: undefined,
            right: '30px',
            transform: undefined
          }}
          oneLine
        />
        <MemberLink personId={data.personId} id={data.confirmationFormId}>
          {data?.personName}
        </MemberLink>
      </CoachMark.SpotLight>
    </S.LabeledInfo>
  );
};

export default Member;
